export const PAYROLL_DATA_CHANGED_EVENT = "payroll-data-changed";

export function notifyPayrollDataChanged(): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(PAYROLL_DATA_CHANGED_EVENT));
}
